export default "__VITE_ASSET__a1571016__"